import { gql } from "apollo-boost";

export const GET_INFO_TOPIC = gql`
  query getInfoTopic($id: ID!) {
    getInfoTopic(
      id: $id
    ) {
      id
      topicLocal topicEng descriptionLocal descriptionEng
      picturePath attachFilePath isStudentFirstPage isShow isFix thumbnail
      infoGroup{
        id color nameLocal nameEng isShow isFix
      }
    }
  }
`;

export const GET_INFO_TOPICS = gql`
  query getInfoTopics {
    getInfoTopics {
      id
      topicLocal topicEng descriptionLocal descriptionEng
      picturePath attachFilePath isStudentFirstPage isShow isFix thumbnail
      infoGroup{
        id color nameLocal nameEng isShow isFix
      }
    }
  }
`;


export const GET_INFO_TOPIC_BY_INFO_GROUP_ID = gql`
  query getInfoTopicsByInfoGroup($infoGroupId: ID!) {
    getInfoTopicsByInfoGroup(
      infoGroupId: $infoGroupId
    ) {
      id
      topicLocal topicEng descriptionLocal descriptionEng
      picturePath attachFilePath isStudentFirstPage isShow isFix thumbnail
      infoGroup{
        id color nameLocal nameEng isShow isFix
      }
    }
  }
`;


export const ADD_INFO_TOPIC = gql`
  mutation addInfoTopic(
    $infoTopicInput: InfoTopicInput,
    $infoGroupId: ID!,
  ) {
    addInfoTopic (
      infoTopicInput: $infoTopicInput,
      infoGroupId: $infoGroupId,
    ) {
      id
      topicLocal topicEng descriptionLocal descriptionEng
      picturePath attachFilePath isStudentFirstPage isShow isFix thumbnail
      infoGroup{
        id color nameLocal nameEng isShow isFix
      }

    }
  }
`;

export const UPDATE_INFO_TOPIC = gql`
  mutation updateInfoTopic(
    $id: ID!,
    $infoTopicInput: InfoTopicInput!,
    $infoGroupId: ID!,
  ) {
    updateInfoTopic (
      id: $id,
      infoTopicInput: $infoTopicInput,
      infoGroupId: $infoGroupId,
    ) {
      id
      topicLocal topicEng descriptionLocal descriptionEng
      picturePath attachFilePath isStudentFirstPage isShow isFix thumbnail
      infoGroup{
        id color nameLocal nameEng isShow isFix
      }
    }
  }
`;

export const DELETE_INFO_TOPIC = gql`
  mutation deleteInfoTopic(
    $id: ID!
  ) {
    deleteInfoTopic (
      id: $id
    ) {
      id
      topicLocal topicEng descriptionLocal descriptionEng
      picturePath attachFilePath isStudentFirstPage isShow isFix thumbnail
      infoGroup{
        id color nameLocal nameEng isShow isFix
      }
    }
  }
`;

